import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'comDoc/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const fetchData2 = query => {  
    
    var list = request({
        url: 'comDoc/selectPage2.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comDoc/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 

export const changeStatus2 = query => {  
    var list = request({
        url: 'comDoc/insertShare.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comDoc/insert.do',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' },
        method: 'post',
        data:   query, 
    }); 
    return list;
};
//获取文件详情
export const getFilesDetail = query => {  
    var list = request({
        url: 'comDoc/getFormartFiles.do', 
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 

//获取文件详情
export const getListData = query => {  
    var list = request({
        url: 'comDoc/getDocFileList.do', 
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const handDelete = query => {  
    var list = request({
        url: 'comDoc/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const deleteMore = query => {  
    var list = request({
        url: 'comDoc/deleteMore.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comDoc/update.do',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' },
        method: 'post',
        data:   query, 
    }); 
    return list;
};


export const fetchSelect = query => {  
    var list = request({
        url: 'comDoc/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
export const downDocFile = query => {  
    var list = request({
        url: 'comDoc/getFileDown.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};